const cn = {
    message: {
        'home': '首页'
    }
}

export default cn